import { DomainData } from "@/lib/api/domain-data";
import { DomainError } from "@/lib/api/domain-error";
import { AxiosRequestConfig } from "axios";
import { Result, ok, err } from "neverthrow";
import apiClient from "./api.client";

export async function request(
  config: AxiosRequestConfig,
): Promise<Result<DomainData, DomainError>> {
  try {
    const response = await apiClient.request(config);
    return ok(new DomainData({ data: response.data, status: response.status }));
  } catch (error: unknown) {
    return err(new DomainError(error));
  }
}
